import type { AnyRestaruant } from 'types';
import {
  hasLesznojeOrdersList,
  hasLubjeOrdersList,
  hasOstrowjeOrdersList,
} from 'utils/restaurant';
import { APITenantConfig, Tenants } from 'store/tenants';

export enum RestaurantPreviewType {
    Menu = 'menu',
    MenuOnPlace = 'menu_on_place',
    Resevations = 'reservations',
  }

export function getRestaurantPreviewHost(
    restaurant: AnyRestaruant,
    type: RestaurantPreviewType,
    tenantConfigs: Record<Tenants, APITenantConfig>
  ): string {
    let domain = tenantConfigs[Tenants.OtoStolik].domain;
    if (type === 'menu' && hasLubjeOrdersList(restaurant)) {
      domain = tenantConfigs[Tenants.LUBJE].domain;
    }
    if (type === 'menu' && hasLesznojeOrdersList(restaurant)) {
      domain = tenantConfigs[Tenants.LesznoJe].domain;
    }
    if (type === 'menu' && hasOstrowjeOrdersList(restaurant)) {
      domain = tenantConfigs[Tenants.OstrowJe].domain;
    }
    const host = domain.includes('local') ? 'http://' : 'https://';
    return `${host}${domain}/`;
  }